import React from "react";
import { ScrollToTopButton } from "../components/ScrollToTopButton/ScrollToTopButton";
import { FooterOne } from "../components/Footers/FooterOne";
import { HeaderOne } from "../components/Headers/HeaderOne";
import { Breadcrumb } from "../components/Breadcrumb/Breadcrumb";
import { HeaderSix } from "../components/Headers/HeaderSix";
import { Seo } from "../components/SEO/Seo";
import { useLocation } from "react-router-dom";

export const Layout = ({
  children,
  header,
  breadcrumb,
  title,
  seo,
}) => {
  const { pathname } = useLocation();

  return (
    <>
      <Seo
        title={seo?.title || title}
        description={seo?.description}
        robots={seo?.robots}
        pathname={seo?.pathname || pathname}
        schemaType={seo?.schemaType}
      />

      {/* Scroll-top  */}
      <ScrollToTopButton />

      {/* header */}
      {header === 1 && <HeaderOne />}
      {(!header || header === 6) && <HeaderSix />}

      {/* breadcrumb */}
      {breadcrumb && <Breadcrumb text={breadcrumb} title={title} />}

      {/* children */}
      <main className="fix">{children}</main>

      {/* footer */}
      <FooterOne />
    </>
  );
};
